var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 434.1 337.9",
    style: {
      enableBackground: "new 0 0 434.1 337.9"
    },
    width: 26,
    height: 26,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.4,63.5c1.1-3.3,2.1-6.5,3.1-9.5c38.8,38.5,77.4,76.7,116,115c-38.8,38.4-77.4,76.6-116.1,115c-0.8-2.3-1.9-5.6-3-8.9 C29.4,204.5,29.4,134,29.4,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.4,275c-1.1,3.3-2.1,6.5-3.1,9.5c-38.8-38.4-77.4-76.7-116-115c38.9-38.5,77.5-76.7,116.2-115c0.8,2.4,1.9,5.7,2.9,8.9 C413.4,134,413.4,204.5,413.4,275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8,36.9c4.7-1,8.5-1.9,12.4-2.6c1.5-0.3,3-0.1,4.5-0.1c103.9,0,207.7,0,311.6,0c5.5,0,10.9,0.6,16.3,3.2 c-1,1.1-1.8,2-2.7,2.9C337.9,93.4,285,146.5,232,199.6c-6.9,7-14.3,7-21.2,0C157.9,146.5,104.9,93.4,52,40.3 C51.2,39.5,50.5,38.7,48.8,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.7,186.2c38.6,38.3,77.1,76.4,116.4,115.3c-4.5,1-8.3,1.9-12.2,2.6c-1.3,0.3-2.7,0.1-4.1,0.1c-104.2,0-208.4,0-312.6,0 c-5.4,0-10.6-0.6-15.8-3.3c38.8-38.4,77.3-76.5,116-114.9c0.3,0.3,1.3,1.2,2.2,2.1c9.2,9.2,18.3,18.4,27.5,27.6 c15.5,15.6,37.1,15.5,52.6,0C257.8,205.8,268,195.8,277.7,186.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e5e38870d2318a577e0fd8d904205755.svg";
export { ForwardRef as ReactComponent };